export function GenerateCargoTable(sscope, list) {
    let isp2p = false
    if (sscope == 'Port-to-Port') isp2p = true
    let ret = `<table><thead><tr>`
    ret += `<th style="border: 1px solid lightgrey">Package Type</th>`
    ret += `<th style="border: 1px solid lightgrey">Num packages</th>`
    if (isp2p) {
        ret += `<th style="border: 1px solid lightgrey">Total Weight</th>`
        ret += `<th style="border: 1px solid lightgrey">Total Volume</th>`
    } else {
        ret += `<th style="border: 1px solid lightgrey">Weight per package</th>`
        ret += `<th style="border: 1px solid lightgrey">Dimensions (LxWxH)</th>`
    }
    ret += `</tr></thead>`
    ret += `<tbody>`
    list.forEach(e => {
        ret += `<tr>`
        ret += `<td style="border: 1px solid lightgrey">${e.packageType}</td>`
        ret += `<td style="border: 1px solid lightgrey">${e.numPackages}</td>`
        if (isp2p) {
            ret += `<td style="border: 1px solid lightgrey">${e.totalWeight}</td>`
            ret += `<td style="border: 1px solid lightgrey">${e.totalVolume}</td>`
        } else {
            ret += `<td style="border: 1px solid lightgrey">${e.wtPerPackage}</td>`
            ret += `<td style="border: 1px solid lightgrey">${e.length} x ${e.width} x ${e.height}</td>`
        }
        ret += `</tr>`
    })
    ret += `</tbody></table>`
    return ret
}